import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  QueryConstraint,
  setDoc,
  updateDoc,
  where,
  WhereFilterOp,
} from "firebase/firestore";
import { firestoreService } from "../../firebase-config";

export function useFirestoreActions() {
  const createCollection = async <T>(path: string, data: any) => {
    return await addDoc(collection(firestoreService, path), data);
  };

  const createCollectionWithId = async <T>(path: string, data: T) => {
    const id = crypto.randomUUID();
    const ref = doc(firestoreService, path, id);
    await setDoc(ref, {
      ...data,
      id,
      createdAt: new Date(),
      updatedAt: new Date(),
    });
    return id;
  };

  const updateCollection = async <T>(
    path: string,
    id: string,
    data: Partial<T>
  ) => {
    const ref = doc(firestoreService, path, id);
    return await updateDoc(ref, data);
  };

  const getById = async <T>(path: string, id: string): Promise<T | null> => {
    const ref = doc(firestoreService, path, id);
    const snap = await getDoc(ref);
    return snap.exists() ? (snap.data() as T) : null;
  };

  const getWhere = async <T>(
    path: string,
    field: string,
    operator: WhereFilterOp,
    value: any
  ): Promise<T[]> => {
    const q = query(
      collection(firestoreService, path),
      where(field, operator, value)
    );
    const snap = await getDocs(q);
    return snap.docs.map((doc) => doc.data() as T);
  };

  const getWhereMultiple = async <T>(
    path: string,
    conditions: Array<{ field: string; operator: WhereFilterOp; value: any }>
  ): Promise<T[]> => {
    const constraints: QueryConstraint[] = conditions.map((c) =>
      where(c.field, c.operator, c.value)
    );

    const q = query(collection(firestoreService, path), ...constraints);
    const snap = await getDocs(q);
    return snap.docs.map((doc) => doc.data() as T);
  };

  return { createCollection, updateCollection, createCollectionWithId };
}
